import React, { Component } from 'react';
import { Row } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import styles from './FeaturedEvent.scss';

class FeaturedEvent extends Component {
  static propTypes = {
    event: PropTypes.object.isRequired,
    publishers: ImmutablePropTypes.list.isRequired,
    isPolling: PropTypes.bool.isRequired,
  };

  render() {
    const { event, publishers } = this.props;
    const imgUrl = event.get('image_url');
    const publisherName = publishers.getIn([0, 'name']);

    return (
      <Row className={styles.FeaturedEvent}>
        <div className='col-12'>
          <div className='fe-banner'>
            {imgUrl && <div className='fe-banner-thumb' style={{ backgroundImage: `url(${imgUrl})` }} />}
            <div className='fe-banner-body'>
              <div className='fe-banner-head'>
                <i className='fa fa-star' />
                <span className='fe-banner-title'>Featured, not just listed</span>
              </div>
              <p className='fe-banner-copy'>
                On top of being promoted across every listing site, your event gets a featured spot
                on the first page of the <b>{publisherName}</b> calendar, so far more people see it.
              </p>
            </div>
          </div>
        </div>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  event: state.checkoutData.get('current_event'),
  publishers: state.checkoutData.getIn(['current_event', 'featuring_publishers']),
  isPolling: state.checkoutData.getIn(['eventImagePolling', 'isPolling'], false),
});

export default connect(
  mapStateToProps,
)(FeaturedEvent);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/FeaturedEvent.jsx